import { useState, useRef, useEffect } from "react"
import BottomSheet from "@components/BottomSheet/BottomSheet"
import BottomSheetHeader from "@components/BottomSheetHeader/BottomSheetHeader"
import NumericKeyboard from "@components/NumericKeyboard/NumericKeyboard"
import PrimaryButton from "@components/PrimaryButton/PrimaryButton"
import { RupiahInputContainer, InputWrapper, AmountLabel, AmountContainer, CurrencySymbol, ErrorMessage, KeyboardContainer, MaxButton } from "./RupiahInput.styles"
import { toCurrencyFormat } from "@lib/utils"
import { BLACK, CRIMSON_500 } from "@styles/colors"
import { useTranslation } from "react-i18next"

export const RupiahInput = ({
    amount,
    onMax,
    handleKeyboardPress,
    isAmountError,
    errorMessage,
    onFocus,
    onBlur
}: {
    amount: number
    onMax?: () => void
    handleKeyboardPress: (value: string) => void
    isAmountError?: boolean
    errorMessage?: string
    onFocus?: () => void
    onBlur?: () => void
}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false)
    const hasBeenOpenedRef = useRef(false)

    const handleOpen = () => {
        onFocus?.()
        hasBeenOpenedRef.current = true
        setIsOpen(true)
    }

    const handleClose = () => {
        setIsOpen(false)
    }

    const handleMax = () => {
        onMax?.()
    }

    useEffect(() => {
        // Only call onBlur when the keyboard is closed AND it has been opened before
        if (!isOpen && hasBeenOpenedRef.current) {
            onBlur?.()
        }
    }, [isOpen])

    return (
        <RupiahInputContainer>
            <InputWrapper onClick={handleOpen}>
                <AmountLabel>{t('components.rupiahInput.amountLabel')}</AmountLabel>
                <AmountContainer style={{ color: isAmountError ? CRIMSON_500 : BLACK }}>
                    <CurrencySymbol>Rp</CurrencySymbol>
                    <span>
                        {toCurrencyFormat(amount)}
                        {onMax && <MaxButton
                            onClick={(e: React.MouseEvent) => {
                                e.stopPropagation()
                                handleMax()
                            }}
                        >
                            Max
                        </MaxButton>}
                    </span>
                </AmountContainer>
                {isAmountError && <ErrorMessage>{errorMessage}</ErrorMessage>}
            </InputWrapper>

            <BottomSheet
                isOpen={isOpen}
                onClose={handleClose}
                header={<BottomSheetHeader plain />}
                footer={null}
                height="50%"
                overlayOpacity={0.1}
            >
                <NumericKeyboard
                    onChange={handleKeyboardPress}
                    emptySpaceButton="thousand"
                />
                <KeyboardContainer>
                    <PrimaryButton onClick={handleClose}>{t('components.rupiahInput.continueButton')}</PrimaryButton>
                </KeyboardContainer>
            </BottomSheet>
        </RupiahInputContainer>
    )
}